import React, { FC } from 'react';
import * as S from './Scoreboard.style';
import { usePlayers } from '../../context/PlayerContext';
import { useGame } from '../../context/GameContext';
import { avatars } from 'utils/avatars';

export const ClassicScoreboard: FC = () => {
  const { players } = usePlayers();
  const { currentTurn, currentRound, gameSettings } = useGame();

  return (
    <S.TableContainer>
      <S.Table aria-label="Scoreboard">
        <S.TableHead>
          <S.TableRow>
            <S.TableCell>Player</S.TableCell>
            {[...Array(gameSettings.totalRounds)].map((_, roundIndex) => (
              <S.TableCell key={roundIndex} align="center" component="th">
                {roundIndex + 1}
              </S.TableCell>
            ))}
            <S.TableCell align="center">Total</S.TableCell>
          </S.TableRow>
        </S.TableHead>
        <S.TableBody>
          {players.map((player, playerIndex) => (
            <S.TableRow
              key={playerIndex}
              disabled={!player.isActive}
              activeRow={playerIndex === currentTurn}
            >
              <S.TableCell component="th">
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    fontWeight: '600',
                  }}
                >
                  <img
                    src={avatars[playerIndex] ?? avatars[avatars.length - 1]}
                    alt={`avatar-${playerIndex}`}
                    style={{
                      width: 25,
                      height: 25,
                      borderRadius: '50%',
                      marginRight: 8,
                    }}
                  />
                  <span>{player.player}</span>
                </div>
              </S.TableCell>
              {player.scores.map((score, roundIndex) => {
                const activeCell =
                  roundIndex === currentRound && playerIndex === currentTurn;

                return (
                  <S.TableCell
                    key={roundIndex}
                    align="center"
                    activeCell={activeCell}
                  >
                    {score !== null && score !== undefined ? score : ''}
                  </S.TableCell>
                );
              })}
              <S.TableCell
                align="center"
                style={{ fontWeight: '600', fontSize: 16 }}
              >
                {(player.scores ?? []).reduce<number>(
                  (sum, score) => sum + (score ?? 0),
                  0
                )}
              </S.TableCell>
            </S.TableRow>
          ))}
        </S.TableBody>
      </S.Table>
    </S.TableContainer>
  );
};
